<template>
  <slot />
</template>

<script setup lang="ts">
import { provide, onUnmounted } from 'vue';
import { FeatureFlagService } from '../services/FeatureFlagService';
import { FEATURE_FLAG_SERVICE_KEY } from '../utils/symbols';
import type { FeatureFlagConfig } from '../types';

interface Props {
  apiKey: string;
  environments?: string[];
}

const props = defineProps<Props>();

// Create service instance
const config: FeatureFlagConfig = {
  apiKey: props.apiKey,
  environments: props.environments as any
};

const service = new FeatureFlagService(config);

// Provide service to children
provide(FEATURE_FLAG_SERVICE_KEY, service);

// Cleanup on unmount
onUnmounted(() => {
  service.destroy();
});
</script>